/* eslint-disable func-names */
/* eslint-disable class-methods-use-this */
import React from 'react';
import openTrueCaller from 'helpers/login/openTrueCaller';
import Cookie from '../../utils/cookies';

class TrueCallerLogin extends React.Component {
  constructor() {
    super();
    this.moduleName = 'truecaller';
    this.state = {
      enableStyle: false,
    };
  }

  onShowCallback = value => {
    if (
      window &&
      window.TimesApps.PopUpList &&
      window.TimesApps.PopUpList[this.moduleName]
    ) {
      window.TimesApps.PopUpList[this.moduleName].callbacks.onShowCallback(
        value,
      );
    }
  };

  openTrueCallerPopup = e => {
    e.preventDefault();
    e.stopPropagation();
    openTrueCaller(
      this.props.jssoObj,
      this.props.loginUserCallback,
      this.onShowCallback,
    );
    this.setState({ enableStyle: false });
  };

  componentDidMount() {
    window.addEventListener(
      'TrueCallerLogin.openTrueCaller',
      () => {
        openTrueCaller(this.props.jssoObj, this.props.loginUserCallback);
      },
      false,
    );
    try {
      window.TimesApps.PopUpV2Manager.cmd.push(() => {
        if (
          window.TimesApps.PopUpV2Manager &&
          window.TimesApps.PopUpV2Manager?.register &&
          typeof window.TimesApps.PopUpV2Manager.register === 'function'
        ) {
          window.TimesApps.PopUpV2Manager.register(this.moduleName, () => {
            const { isWapView } = this.props;
            this.channel = isWapView ? 'toi-wap' : 'toi';
            const ssoid = Cookie.get('ssoid') || Cookie.get('ssoId');
            if (ssoid || !isWapView) {
              // user id is already exists
              this.onShowCallback(false);
              return;
            }
            if (
              isWapView &&
              typeof window === 'object' &&
              window.TimesGDPR &&
              window.TimesGDPR.common.consentModule.gdprCallback
            ) {
              window.TimesGDPR.common.consentModule.gdprCallback(dataObj => {
                if (
                  this.props.jssoObj?.truecallerOneTapLoginV1 &&
                  typeof this.props.jssoObj?.truecallerOneTapLoginV1 ===
                    'function' &&
                  (!(
                    dataObj.isEUuser ||
                    (dataObj.userCountry === 'US' &&
                      dataObj.userRegion === 'CA')
                  ) ||
                    dataObj.consentGiven)
                ) {
                  this.setState({
                    enableStyle: true,
                  });
                }
              });
            }
          });
        }
      });
    } catch (error) {
      console.log('Error in registering onetap popup');
    }
  }

  render() {
    return this.props.isWapView ? (
      <div
        className="truecaller_onetap_wrapper"
        id="truecaller_onetap_wrapper"
        style={
          this.state.enableStyle
            ? {
                position: 'absolute',
                height: '100vh',
                width: '100vw',
                top: 0,
                left: 0,
                zIndex: 100000000000,
              }
            : {}
        }
        onClick={this.state.enableStyle ? this.openTrueCallerPopup : undefined}
      />
    ) : (
      <></>
    );
  }
}

export default TrueCallerLogin;
